export default __webpack_public_path__ + "static/media/338.10f49d34.png";